import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const postRecallGMPAPI = createApi(`RecallGMPSlice`,"POST");

const RecallGMPSlice = createSlice({
  name: 'RecallGMPSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postRecallGMPAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postRecallGMPAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postRecallGMPAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default RecallGMPSlice.reducer;